var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowCornerDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.67 12.42h4.01c.43 0 .66.56.37.91l-6.71 8.3c-.4.5-1.1.5-1.5 0l-6.71-8.3c-.29-.35-.06-.91.37-.91h4.01c0-.16-.3-11.32 12.04-10.36.51.04.62.79.15 1.03-4 2.02-6.03 4.36-6.03 9.33z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowCornerDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-corner-down.d7b2ad5af0437a20df70d26bef766776.svg";